import type { z } from 'zod';
import { Globe } from 'lucide-react';

import type { EcosystemRecordSchema } from '@ballerine/common';

import { EcosystemCardList } from '@/components/templates/shared/Ecosystem/components/EcosystemCardList';
import { ReportWrapper } from '../components/ReportWrapper';

type EcosystemSectionProps = {
  ecosystem?: Array<z.infer<typeof EcosystemRecordSchema>> | null;
};

export const EcosystemSection = ({ ecosystem }: EcosystemSectionProps) => {
  return (
    <ReportWrapper
      title="Ecosystem"
      Icon={Globe}
      tooltip="Digital ecosystem analysis including related websites and business connections."
      showTooltip={false}
    >
      <EcosystemCardList ecosystem={ecosystem ?? []} />
    </ReportWrapper>
  );
};
